module.exports = __webpack_public_path__ + "static/02-c1006322d4de80166ca5985cd54edc71.png";